export default function NextArticlePopup() {
	let hasShown = false;

	if (typeof window.jQuery !== 'undefined') {
		window.jQuery(document).ready(($) => {
			const articleContent = $('.article-content')[0];
			const nextArticlePopup = $('#next-article-popup');

			$(document).scroll(() => {
				if (!hasShown && nextArticlePopup && articleContent) {
					const scrollPos = window.scrollY;

					const articleHeight = articleContent.scrollHeight;

					if (scrollPos > (articleHeight * 0.75)) {
						nextArticlePopup.slideToggle('slow');

						hasShown = true;
					}
				}
			});

			$('#next-article-popup-close').click(() => {
				if (nextArticlePopup) {
					nextArticlePopup.slideToggle('slow');
				}
			});
		});
	}
}
